import { data } from '../storage'

export default function getStores() {
    const control = Object.values(data.controlLists).map(cl => cl.list)
    return [...control].flat()
}
